import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { CheckBoxDisplay } from './CheckBoxDisplay';

interface Props {
  value?: boolean;
  previousValue?: boolean | null;
  onClose: () => void;
  fieldName: string;
  content?: string;
}

export const CheckBoxDiffModal = ({
  value,
  previousValue,
  onClose,
  fieldName,
  content
}: Props) => {
  const prevZeroState = typeof previousValue !== 'boolean';
  const currentZeroState = typeof value !== 'boolean';

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {fieldName} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={fieldName}>
        {prevZeroState ? (
          zeroState
        ) : (
          <CheckBoxDisplay
            value={previousValue as boolean}
            content={content}
          />
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={fieldName}>
        {currentZeroState ? (
          zeroState
        ) : (
          <CheckBoxDisplay
            value={value as boolean}
            content={content}
          />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
